module.exports = __webpack_public_path__ + "static/media/dron.fe857081.png";